import React, { PropsWithChildren, useReducer, useState, useCallback } from 'react';
import { Nullable } from '@dxb-web-ui-framework/common/types';
import { useInvokeSWRService } from '@dxb-web-ui-framework/common/hooks/DataService';
import { communicationService } from '../../../../../channels/secure-web/services';
import { useSelectedCustomerId } from '../UserInfo/hooks';
import { CommunicationContext } from './CommunicationContext';
import { defaultCommunicationProviderState } from './defaultState';
import { CommunicationProviderProps } from './types';
import { CommunicationReducer } from './CommunicationReducer';

const CommunicationProvider = ({ children }: PropsWithChildren<CommunicationProviderProps>) => {
  const [state] = useReducer(CommunicationReducer, defaultCommunicationProviderState());
  const [timestamp, setTimestamp] = useState<Nullable<string>>(null);
  const customerId = useSelectedCustomerId();

  const shouldFetchCommunicationAlertsData = Boolean(customerId) && Boolean(timestamp);

  const {
    data: communicationAlertsListData,
    error: communicationAlertsListDataError,
    isLoading: isLoadingCommunicationAlertsListData,
  } = useInvokeSWRService(
    communicationService.GetCommunicationAlerts,
    {
      customerId,
      meta: {
        timestamp,
      },
    },
    shouldFetchCommunicationAlertsData,
    'communicationService.GetCommunicationAlerts',
  );

  const refetchCommunicationAlertListData = useCallback(() => {
    setTimestamp(new Date().toISOString());
  }, []);

  return (
    <CommunicationContext.Provider
      value={{
        ...state,
        communicationAlertsList: communicationAlertsListData,
        loadingState: {
          isLoadingCommunicationAlertsListData,
        },
        errorState: {
          communicationAlertsListDataError,
        },
        refetchCommunicationAlertListData,
      }}>
      {children}
    </CommunicationContext.Provider>
  );
};

export { CommunicationProvider };
